import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

const PayoutDetails = () => {
  const [earnings, setEarnings] = useState([]);

  useEffect(() => {
    const fetchEarnings = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
    
        try {
          const response = await axios.post(
            `${params.baseURL}${params.endpoints.getEarnings}`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
    
          if (response.data.status === 'success') {
            const data = response.data.data;
    
            setEarnings(data);
          } else {
            toast.error('Unable to fetch earnings. Try again.');
          }
        } catch (error) {
          console.error('Error fetching earnings:', error);
          toast.error('An error occurred while fetching earnings.');
        }
    };
    fetchEarnings();
  }, []);

  /*const handleSearch = () => {
    fetchEarnings();
  };*/

  const calculateDaysAgo = (dateString) => {
    if (!dateString) return "-";
    const today = new Date();
    const date = new Date(dateString);
    const diffTime = Math.abs(today - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} days`;
  };

  return (
    <div>
      <Helmet>
        <title>Payout Details</title>
        <meta name="description" content="" />
      </Helmet>

      <div className="earning-section">
        <div className="payout-card">
            <div className="payout-header">
                <div className="amount">₹ 9,764.00</div>
                <span className="status processed">Processed</span>
            </div>
            <p className="created-date">Created on Tue Nov 9, <span className="time">01:35pm</span></p>

            <div className="settlement-box">
                <div className="section">
                    <h4>Gross settlement</h4>
                    <div className="pdvs">
                        <span>Payment</span>
                        <span className="green">₹ 10,000.00</span>
                    </div>
                </div>

                <div className="section">
                    <h4>Deductions</h4>
                    <div className="pdvs">
                        <span>Tax</span>
                        <span className="red">₹ 36.00</span>
                    </div>
                    <div className="pdvs">
                        <span>Fee</span>
                        <span className="red">₹ 200.00</span>
                    </div>
                </div>

                <div className="pdvs net">
                    <strong>Net settlements</strong>
                    <strong>₹ 9,764.00</strong>
                </div>
            </div>

            <div className="details-box">
                <h4>Details</h4>
                <div className="pdvs">
                    <span>Settlement ID</span>
                    <span className="bold">setl_IJQt3WHfsBbhTE</span>
                </div>
                <div className="pdvs">
                    <span>UTR number</span>
                    <span>1636445109687c2n</span>
                </div>
            </div>
        </div>

        <section className="payout-card mt-4" id="earnings-table">
          <h2 className="tnstxt">Gross Settlements</h2>
          <div className="table-flex">
            <div className="table-row table-header">
              <div className="table-cell" style={{width:'250px'}}>
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                Gross amount
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                Deductions
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                Net amount
              </div>
            </div>

            {earnings.length > 0 ? (
              earnings.map((earning, index) => (
                <div className="table-row" key={index}>
                  <div className="table-cell" style={{width:'250px', textTransform:'uppercase'}}>
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR 10,000.00
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR 236.00
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR 9,764.00
                  </div>
                </div>
              ))
            ) : (
              <div className="table-row">
                <div className="table-cell text-center" style={{ flex: '1 0 100%' }}>
                  No earnings found.
                </div>
              </div>
            )}
          </div>
        </section>

      </div>

    </div>
  );
};

export default PayoutDetails;
